import { connect } from 'react-redux';

import { WixConnect } from 'shared/utils/wix-connect';

import { canShowMainItemPublisher, canShowMainItemTitle } from 'shared/selectors/app-settings';

import OverlayMemberOnlyBase from 'widget/components/player-overlay/_base-member-only-overlay';

import styles from './member-only.styl';


@connect(state => ({
  canShowMainItemTitle: canShowMainItemTitle(state),
  canShowMainItemPublisher: canShowMainItemPublisher(state),
}))
@WixConnect(styles)
export default class OverlayMemberOnly extends OverlayMemberOnlyBase {

  static displayName = 'OverlayMemberOnly';
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/classic/member-only.js